
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M17.968.843H5.625A4.875 4.875 0 00.75 5.718V18.06a4.875 4.875 0 004.875 4.874h12.343a4.875 4.875 0 004.875-4.874V5.718A4.875 4.875 0 0017.968.843zM.75 6.809h22.093"}}),_c('path',{attrs:{"stroke-linejoin":"round","d":"M6.376 15.013l3.417 3.417 7.424-7.424"}})])])
          )
        }
      }
    